import { render, staticRenderFns } from "./OfficesList.vue?vue&type=template&id=223d7962"
import script from "./OfficesList.vue?vue&type=script&lang=ts"
export * from "./OfficesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports